/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { Provider } from 'jotai'
import { DevTools } from 'jotai-devtools'
import React from 'react'

/** A description of the available properties for this component. */
type JotaiProviderProps = {
  /** The children to render. */
  children: React.ReactNode
}

/**
 * Wraps the {@link Provider} from `jotai` in a component that uses the `use client` directive.
 */
const JotaiProvider: React.FC<JotaiProviderProps> = ({ children }) => {
  return (
    <Provider>
      <DevTools />
      {children}
    </Provider>
  )
}

export { JotaiProvider }
